module.exports = __webpack_public_path__ + "img/cash.835423d8.svg";